import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {
  EmailApi, EmailMessage, EmailTemplateEditorInfo, SortParameters, HttpStatusCode, LookupApi,
  LookupField, FilterParams
} from 'src/app/core/api.gen';
import { CommonService } from 'src/app/core/common.service';
import { LookupTypeKeys } from 'src/app/shared/lookup-type-keys';
import { UntypedFormGroup, FormBuilder, Validators, UntypedFormControl, UntypedFormArray } from "@angular/forms";
import { finalize, map } from 'rxjs/operators';
import { LoaderService } from 'src/app/core/loader.service';
import { ToastService } from 'src/app/core';
//import { update } from 'xstate/lib/actionTypes';
import { isNullOrUndefined } from '../../../../app/core/utils';

@Component({
  selector: 'eos-template-selector',
  templateUrl: './template-selector.component.html',
  styleUrls: ['./template-selector.component.css']
})
export class TemplateSelectorComponent implements OnInit {

  @Input() public email: EmailMessage;
  @Input() public searchparameter: EmailTemplateEditorInfo;
  empCategories: LookupField[] = [];
  officeLocations: LookupField[] = [];
  pbTypes: LookupField[] = [];
  dropdownSettings = {};
  currentPage = 1;
  page: number;
  changeCount: number[] = [10, 15, 25];
  totalPages: number;
  sortParameters: SortParameters;
  disableSearch = false;
  tempSelected: number[] = [];
  isDataAvailable = false;
  selectAlltemps: boolean;
  isExit : boolean = false;
  exitTypes: LookupField[] = [];

  templateForm = new UntypedFormGroup({
    employeeCategory: new UntypedFormControl('', [Validators.required]),
    officeLocation: new UntypedFormControl('', [Validators.required]),
    pbType: new UntypedFormControl('', [Validators.required]),
    templateSearch: new UntypedFormControl('', [Validators.required]),
    templatetoChange: new UntypedFormArray([]),
    isWSO: new UntypedFormControl(false, [Validators.required]),
  });

  exitTemplateForm = new UntypedFormGroup({
    officeLocation: new UntypedFormControl('', [Validators.required]),
    exitType: new UntypedFormControl('', [Validators.required]),
    templateSearch: new UntypedFormControl('', [Validators.required]),
    templatetoChange: new UntypedFormArray([]),
  });
  templateList: EmailTemplateEditorInfo[];
  constructor(public modal: NgbActiveModal,
    private lookUpService: LookupApi,
    private emailApi: EmailApi,
    private loader: LoaderService,
    private toast: ToastService) {
    this.sortParameters = new SortParameters();
    this.sortParameters.filterParams = new FilterParams();
  }

  ngOnInit() {
    if (this.searchparameter.code && this.searchparameter.code.includes('ext')) {
      this.isExit = true;
      this.getExitTypes();
      this.exitTemplateForm.patchValue({
        templateSearch: this.searchparameter.activityHeader
      });
    } 

    this.templateForm.patchValue({
      templateSearch: this.searchparameter.activityHeader
    });
    this.getLocations();
    this.getempcategory();
    this.getpbTypes();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'displayText',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    this.sortParameters.page = 1;
    this.sortParameters.itemsPerPage = 10;
    this.sortParameters.totalRecords = 0;

  }

  get showControl() {
    const search = this.templateForm.getRawValue();
    if (search.employeeCategory && search.employeeCategory.map(({ id }) => id).includes(717)) {
      return true;
    }
    return false;
  }

  search() {
    if(this.isExit){
      const search = this.exitTemplateForm.getRawValue();
      this.sortParameters.filterParams.officeLocationId = search.officeLocation.map(({ id }) => id);
      this.sortParameters.filterParams.exitTypeId = search.exitType.map(({ id }) => id);
      this.sortParameters.filterParams.searchParameter = search.templateSearch.trim();
    }
    else{
      const search = this.templateForm.getRawValue();
      this.sortParameters.filterParams.officeLocationId = search.officeLocation.map(({ id }) => id);
      this.sortParameters.filterParams.employeeCategoryId = search.employeeCategory.map(({ id }) => id);
      this.sortParameters.filterParams.pbTypeId = search.pbType.map(({ id }) => id);
      this.sortParameters.filterParams.isWSO = search.isWSO;
      this.sortParameters.filterParams.searchParameter = search.templateSearch.trim();
    }
    this.getGridDetails();
    this.tempSelected = [];
  }

  pageChanged(event: any): void {
    this.sortParameters.itemsPerPage = event.itemsPerPage;
    this.sortParameters.page = event.page;
    this.getGridDetails();
    const formArray: UntypedFormArray = this.templateForm.get('templatetoChange') as UntypedFormArray;

  }

  getGridDetails() {
    this.loader.show();
    this.emailApi.getEmailTemplatesForEdit(this.sortParameters).pipe(
      finalize(() => this.loader.clear())
    ).subscribe(em => {
      this.templateList = em.results;
      this.sortParameters.totalRecords = em.totalRecords;
      if (this.templateList.length > 0) {
        this.templateList.forEach(x => x['checked'] = this.tempSelected.includes(x.id));
        this.isDataAvailable = true;
      }
    });
  }

  onSelectChanges() {
    this.getGridDetails();
  }

  getLocations() {
    const ob$ = this.lookUpService.getLookupTypeById(LookupTypeKeys.OFFICE_LOCATION, undefined);
    ob$.subscribe(resp => {
      this.officeLocations = resp.lookupFields;
    });
    return ob$;
  }
  getempcategory() {
    const ob$ = this.lookUpService.getLookupTypeById(LookupTypeKeys.EMPLOYEE_CATEGORY_TYPES, undefined);
    ob$.subscribe(resp => {
      this.empCategories = resp.lookupFields;
    });
    return ob$;
  }
  getpbTypes() {
    const ob$ = this.lookUpService.getLookupTypeById(LookupTypeKeys.ONBOARDING_TYPES, undefined);
    ob$.subscribe(resp => {
      this.pbTypes = resp.lookupFields;
    });
    return ob$;
  }
  getExitTypes(){
    const ob$ = this.lookUpService.getLookupTypeById(LookupTypeKeys.EXIT_TYPES, undefined);
    ob$.subscribe(resp => {
      this.exitTypes = resp.lookupFields;
    });
    return ob$;
  }
  onCheckChange(item: EmailTemplateEditorInfo) {
    item['checked'] = !item['checked']
    if (item['checked']) {
      this.tempSelected.push(item.id);
    } else {
      this.tempSelected = this.tempSelected.filter(obj => obj !== item.id);
    }
  }



  save() {
    const search = this.templateForm.getRawValue();
    this.loader.show();
    this.emailApi.saveEmailTemplateToMany(this.email.activityTemplateId, this.tempSelected)
      .pipe(finalize(() => this.loader.clear()))
      .subscribe(result => {

        if (result.statusCode == HttpStatusCode.Created) {
          this.toast.success("Template updated successfully");
        }
      }, err => {
        this.toast.error("Something went wrong!");
      });
  }

  selectAll() {
    this.templateList.forEach(x => {
      x['checked'] = true;
      if (!this.tempSelected.includes(x.id)) {
        this.tempSelected.push(x.id);
      }
    });
  }
  unselectAll() {
    this.templateList.forEach((x) => {
      x['checked'] = false;
      if (this.tempSelected.includes(x.id)) {
        this.tempSelected.splice(this.tempSelected.indexOf(x.id), 1);
      }
    });
  }

  get enableSearch(): boolean {
    if(this.isExit){
      return !this.exitTemplateForm.invalid;
    }
    return !this.templateForm.invalid;
  }







}
